import { SUPPORTED_LANGUAGES } from '@atlaskit/code/constants';
import { getDefaultCodeBlockAttrs } from '@atlaskit/editor-common/code-block';
import { mapSlice } from '@atlaskit/editor-common/utils';
import type { Slice } from '@atlaskit/editor-prosemirror/model';
import type { EditorState } from '@atlaskit/editor-prosemirror/state';

interface VSCodeBlockParams {
	event: ClipboardEvent;
	slice: Slice;
	state: EditorState;
	text: string;
}

function safelyGetVSCodeLanguage(editorData: string | undefined) {
	try {
		const vscodeData = editorData ? JSON.parse(editorData) : undefined;
		return vscodeData?.mode;
	} catch {}
}

export function handleVSCodeBlock({ state, slice, text, event }: VSCodeBlockParams): Slice {
	const vscodeData = event?.clipboardData?.getData('vscode-editor-data');
	const language = safelyGetVSCodeLanguage(vscodeData);
	if (text && language && SUPPORTED_LANGUAGES.some((l) => l.alias[0] === language)) {
		const { schema } = state;
		slice = mapSlice(slice, (node) => {
			if (node.type.name === schema.nodes.codeBlock?.name) {
				return schema.nodes.codeBlock.createChecked(
					getDefaultCodeBlockAttrs({ language }),
					schema.text(text),
				);
			}
			return node;
		});
	}
	return slice;
}
